exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avatar-name{align-items:center;text-align:center;margin:0 auto}.avatar-name__text{font-family:'Inter-semibold';font-weight:normal;font-size:14px;line-height:1.5;color:#000}.user-detail__content .el-row{margin-bottom:12px}.user-detail__content .infor{margin-top:16px}.redemption-detail-content{padding:15px}.dk-editor-view{color:#000000}.condition-detail-content{padding:15px}\n", ""]);

// exports
